<!-- Toast notifications -->
<p-toast key="main"></p-toast>

<!-- Modern Header Section -->
<div class="mt-4 ml-4 mr-4 header-section">
  <div class="header-content">
    <div class="header-left">
      <h1 class="page-title">
        <i class="pi pi-shopping-bag"></i>
        My Sales Orders
      </h1>
      <p class="page-subtitle">View and manage your sales orders</p>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="mt-4 clinic-orders-content">
  <div class="content-section">
    <div class="section-header">
      <div class="header-info">
        <h2 class="section-title">Order Management</h2>
        <p class="section-description">
          View and manage your sales orders
        </p>
      </div>
    </div>

    <div class="overflow-auto">
      <p-table
        #salesOrdersTable
        [value]="orders"
        [paginator]="true"
        [rows]="10"
        [lazy]="true"
        scrollHeight="50vh"
        (onLazyLoad)="lazyLoadOrders($event)"
        [totalRecords]="metaData.totalRecords"
        [loading]="metaData.loading"
        class="modern-table"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
      >
        <ng-template pTemplate="caption">
          <div class="table-search">
            <div class="search-container">
              <i class="pi pi-search search-icon"></i>
              <input
                pInputText
                type="text"
                name="globalFilter"
                (input)="
                  salesOrdersTable.filterGlobal(
                    getFilterInputValue($event),
                    'contains'
                  )
                "
                placeholder="Search orders..."
                class="modern-search"
              />
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr class="table-header">
            <th
              *ngFor="let col of productColumns"
              [pSortableColumn]="col.field"
            >
              <div class="header-cell">
                {{ col.header }}
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-order let-expanded="expanded">
          <tr class="table-row">
            <td *ngFor="let col of productColumns" class="table-cell">
              <div class="cell-content">
                <!-- if field is a date format to yy-MM-dd -->
                <span
                  *ngIf="col.field === 'order_date' || col.field === 'date_required'"
                  class="cell-text"
                >
                  {{ resolveField(order, col.field) | date : "yyyy-MM-dd" }}
                </span>
                <!-- if its total needs to be formatted to R -->
                <span *ngIf="col.field === 'order_total'" class="cell-text">
                  {{ resolveField(order, col.field) | currency : "R" : "symbol" }}
                </span>
                <!-- otherwise show as normal -->
                <span
                  *ngIf="col.field !== 'order_date' && col.field !== 'date_required' && col.field !== 'order_total'"
                  class="cell-text"
                >
                  {{ resolveField(order, col.field) }}
                </span>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              [attr.colspan]="productColumns.length"
              class="empty-state"
            >
              <p-progressBar
                *ngIf="metaData.loading"
                mode="indeterminate"
              >
              </p-progressBar>

              <div
                *ngIf="!metaData.loading"
                class="empty-content"
              >
                <i class="pi pi-shopping-bag empty-icon"></i>
                <h3>No orders found</h3>
                <p>No sales orders are currently available</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
